export enum Devices {
  MOBILE = 'Mobile',
  DESKTOP = 'Desktop',
}

export enum TreeNodeTypes {
  VIEW = 'View',
  ROW = 'Row',
  COL = 'Col',
  FEATURE = 'Feature',
}

export type ColWidth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export type DeviceLayout = ViewLayout;

export interface TreeNodeId {
  id?: string;
}

export interface TreeNodeChildren<T> {
  children: T[];
}

export interface TreeNodeType<T extends TreeNodeTypes> {
  type: T;
}

export enum FeatureLayout {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
  DRAWER = 'DRAWER',
  BANNER = 'BANNER',
}

export interface ViewLayout
  extends
    TreeNodeId,
    TreeNodeChildren<RowLayout>,
    TreeNodeType<TreeNodeTypes.VIEW> {}
export interface RowLayout
  extends
    TreeNodeId,
    TreeNodeChildren<ColLayout>,
    TreeNodeType<TreeNodeTypes.ROW> {}
export interface ColLayout
  extends
    TreeNodeId,
    TreeNodeChildren<Feature | RowLayout>,
    TreeNodeType<TreeNodeTypes.COL> {
  width?: ColWidth;
}
export interface Feature
  extends TreeNodeId, TreeNodeType<TreeNodeTypes.FEATURE> {
  name: string;
  options?: {
    layout?: FeatureLayout | null;
    assetId?: string | null;
    sectionDividerId?: string | null;
    fixedPanelHeight?: string | null;
    conditions?: Condition[] | null;
    customFeature?: {
      url?: string;
      settings?: Record<string, unknown>;
      graphqlQuery?: string;
    } | null;
  } | null;
}

export type Condition =
  | ShipmentStatusCondition
  | ShipmentSubStatusCondition
  | CarrierCondition
  | CategoryCondition;

export enum ConditionType {
  SHIPMENT_STATUS = 'SHIPMENT_STATUS',
  SUB_STATUS = 'SUB_STATUS',
  CARRIER_MONIKER = 'CARRIER_MONIKER',
  CATEGORY = 'CATEGORY',
}

export enum ConditionOperator {
  EQ = 'EQ',
  NEQ = 'NEQ',
  IN = 'IN',
}

export interface ShipmentStatusCondition {
  type: ConditionType.SHIPMENT_STATUS;
  status: ShipmentStatusConditionStatus;
  operator?: ConditionOperator;
}

export interface ShipmentSubStatusCondition {
  type: ConditionType.SUB_STATUS;
  subStatus:
    | ShipmentSubStatusConditionStatus
    | ShipmentSubStatusConditionStatus[];
  operator?: ConditionOperator;
}

export enum ShipmentStatusConditionStatus {
  JUSTSHIPPED = 'JUSTSHIPPED',
  INTRANSIT = 'INTRANSIT',
  DELIVERED = 'DELIVERED',
  EXCEPTION = 'EXCEPTION',
  PROCESSING = 'PROCESSING',
  PRESHIPMENT0 = 'PRESHIPMENT0',
  PRESHIPMENT1 = 'PRESHIPMENT1',
  PRESHIPMENT2 = 'PRESHIPMENT2',
  PRESHIPMENT3 = 'PRESHIPMENT3',
  PRESHIPMENT4 = 'PRESHIPMENT4',
  PRESHIPMENT5 = 'PRESHIPMENT5',
  PRESHIPMENT6 = 'PRESHIPMENT6',
  PRESHIPMENT7 = 'PRESHIPMENT7',
  PRESHIPMENT8 = 'PRESHIPMENT8',
  PRESHIPMENT9 = 'PRESHIPMENT9',
  BOPISPROCESSING = 'BOPISPROCESSING',
  BOPISDELAYED = 'BOPISDELAYED',
  BOPISREADYFORPICKUP = 'BOPISREADYFORPICKUP',
  BOPISPICKEDUP = 'BOPISPICKEDUP',
  BOPISCANCELLED = 'BOPISCANCELED',
  LDORDERPLACED = 'LDORDERPLACED',
  LDPICKUPINPROGRESS = 'LDPICKUPINPROGRESS',
  LDONITSWAY = 'LDONITSWAY',
  LDDELIVERED = 'LDDELIVERED',
  LDEXCEPTION = 'LDEXCEPTION',
  HPUSCHEDULED = 'HPUSCHEDULED',
  HPUPICKUPINPROGRESS = 'HPUPICKUPINPROGRESS',
  HPUPICKEDUP = 'HPUPICKEDUP',
  HPUEXCEPTION = 'HPUEXCEPTION',
}

export enum ShipmentSubStatusConditionStatus {
  SHPD = 'SHPD',
  INTR = 'INTR',
  OFDL = 'OFDL',
  DLVD = 'DLVD',
  DLPP = 'DLPP',
  PUBC = 'PUBC',
  ITTS = 'ITTS',
  ITPP = 'ITPP',
  DLTS = 'DLTS',
  EXCP = 'EXCP',
  UNDL = 'UNDL',
  BOSS = 'BOSS',
  BOPIS = 'BOPIS',
  UNKN = 'UNKN',
  SHPD_SDD_101 = 'SHPD_SDD_101',
  SHPD_SDD_201 = 'SHPD_SDD_201',
  SHPD_SDD_280 = 'SHPD_SDD_280',
  SHPD_SDD_281 = 'SHPD_SDD_281',
  INTR_SDD_311 = 'INTR_SDD_311',
  OFDL_SDD_400 = 'OFDL_SDD_400',
  OFDL_SDD_403 = 'OFDL_SDD_403',
  DLVD_SDD_500 = 'DLVD_SDD_500',
  UNDL_SDD_700 = 'UNDL_SDD_700',
  EXCP_SDD_800 = 'EXCP_SDD_800',
}

// Default status for a track page. This is just a fail safe. Actual
// setting of a "default tracking status" is done further upstream
export const DEFAULT_NARVAR_STATUS = ShipmentStatusConditionStatus.JUSTSHIPPED;

export interface CarrierCondition {
  type: ConditionType.CARRIER_MONIKER;
  carrierMoniker: CarrierConditionMoniker | CarrierConditionMoniker[];
  operator?: ConditionOperator;
}

export enum CarrierConditionMoniker {
  UPS = 'ups',
  FEDEX = 'fedex',
  METRO = 'metro',
  PILOT = 'pilot',
}

export interface CategoryCondition {
  type: ConditionType.CATEGORY;
  category: CategoryConditionCategory;
  operator?: ConditionOperator;
}

export enum CategoryConditionCategory {
  SHARING = 'sharing',
}

export interface TreeNode
  extends
    TreeNodeType<TreeNodeTypes>,
    TreeNodeId,
    Partial<TreeNodeChildren<TreeNode>> {}
